/**
 * Injects Lux extras into the Impower document editor
 * (#GeneralDocumentData): case/subject comboboxes and one-click confirm.
 */

const onDocumentEditorPageMatch = () => {
  luxAblegenBeginVisit()

  const tryInject = () => {
    if (document.querySelector('#GeneralDocumentData')) {
      documentConfirmButton()
    }

    const row = document.querySelector(
      '#GeneralDocumentData .section-content > .ant-row'
    )
    const hasCase = row && row.querySelector('#luxDocumentCaseComboBox')
    const hasSubjectLinks = row && row.querySelector('#luxDocumentTechnicalAssetsComboBox')
    if (!row || (hasCase && hasSubjectLinks)) {
      return Boolean(hasCase && hasSubjectLinks)
    }
    if (!hasCase) documentEditorCaseComboBox()
    if (!hasSubjectLinks) documentEditorSubjectLinksComboBox()
    return Boolean(
      row.querySelector('#luxDocumentCaseComboBox') &&
        row.querySelector('#luxDocumentTechnicalAssetsComboBox')
    )
  }

  if (tryInject()) {
    return
  }

  const interval = setInterval(() => {
    if (tryInject()) {
      clearInterval(interval)
    }
  }, 300)

  setTimeout(() => clearInterval(interval), 60000)
}
